// extracted by mini-css-extract-plugin
module.exports = {"w10vw3sr":"w10vw3sr","c35z2b7":"c35z2b7"};